var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5 4.824h1.002c.03.524.465.94.998.94.533 0 .968-.416.998-.94h4.004c.03.524.465.94.998.94.533 0 .968-.416.998-.94H15c.552 0 1 .42 1 .94v.942H4v-.941c0-.52.448-.941 1-.941zm8.998-1.883H15c1.657 0 3 1.264 3 2.824v8.706c0 1.429-1.343 2.588-3 2.588H5c-1.657 0-3-1.159-3-2.588V5.765C2 4.205 3.343 2.94 5 2.94h1.002C6.032 2.416 6.467 2 7 2c.533 0 .968.416.998.941h4.004c.03-.525.465-.941.998-.941.533 0 .968.416.998.941zM4 8.588v5.883c0 .476.448.862 1 .862h10c.552 0 1-.386 1-.862V8.588H4z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarLine);
export default __webpack_public_path__ + "static/media/calendar-line.03fa3f0439c140195f646a6a54217f11.svg";
export { ForwardRef as ReactComponent };